import ENV from "./Environment";
import Requests from "./Requests";

const baseUrl = `${ENV.base_url}/api/v1/ai_intelligence/documents`;

const getDocuments = async (userData, page = 1, pageSize = 10) => {
  const params = new URLSearchParams({ page, page_size: pageSize });
  const response = await Requests.getRequest(`${baseUrl}?${params}`, userData.jwtToken, userData);
  if (!response || !response.ok) throw new Error("Unable to load ingested documents.");
  const data = await response.json();
  if (!Array.isArray(data.content) || !Number.isInteger(data.total_pages) || data.total_pages < 0) {
    throw new Error("The documents response was invalid.");
  }
  return data;
};

const getContent = async (userData, sourceDocumentId, page = 1) => {
  const url = `${baseUrl}/${encodeURIComponent(sourceDocumentId)}/content?page=${page}&page_size=100`;
  const response = await Requests.getRequest(url, userData.jwtToken, userData);
  if (!response || !response.ok) throw new Error("Unable to load document content.");
  return response.json();
};

const IngestedDocumentsService = { getDocuments, getContent };
export default IngestedDocumentsService;
